const state = () => ({
  showErrorBanner: false,
  forceHideErrorBanner: false,
  errorBannerTitle:
    'If you need help, please call 906-HIGHWAY or email us at service@highway.com.',
  all_errors: [],
  excludedEndpoints: [
    '/identity/refresh_jwt',
    '/identity/sign_up/check_for_open_user_invitation',
    '/identity/sign_up/claim_open_user_invitation',
    '/identity/sign_up/has_carrier_been_claimed',
    '/identity/sign_up/does_verified_phone_match_carrier_census_phone',
    '/identity/sign_up/does_verified_email_address_match_carrier_census_email_address',
    '/identity/api/v1/onboarding_packets/find_or_create_connection_and_create_onboarding_packet',
    '/identity/api/v1/companies/public_details?oauth_uid=null',
    '/monitor/refresh_jwt',
    '/monitor/api/v1/companies/public_details?oauth_uid=null',
  ],
});

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setShowErrorBanner(state, bool) {
    state.showErrorBanner = bool;
  },
  setForceHideErrorBanner(state, bool) {
    state.forceHideErrorBanner = bool;
  },
  setAllErrors(state, data) {
    state.all_errors.push(data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
